module.exports = __webpack_public_path__ + "img/single-mic-sprite.d56fc10b.svg";